export enum DomainTypeGq {
  PROJECT = 'PROJECT',
  COMPETITOR = 'COMPETITOR',
  AUTOMATIC = 'AUTOMATIC',
}

export function domainTypeToString(domainType: DomainTypeGq): string {
  if (domainType === DomainTypeGq.PROJECT) {
    return 'Project';
  }
  if (domainType === DomainTypeGq.AUTOMATIC) {
    return 'Automatic';
  }
  return 'Competitor';
}
